import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const LowerSectionAnimation = () => {
  const containers = document.querySelectorAll(".lower-section");
  if (containers.length < 1) {
    return;
  }

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  const base = {
    y: 0,
    opacity: 1,
    duration: 1,
    ease: "power2.inOut",
  };

  const applyAnimations = () => {
    containers.forEach((container) => {
      const headline = container.querySelectorAll(".lower-section__headline");
      const subline = container.querySelectorAll(".lower-section__subline");
      const singleTeaserIcon = container.querySelectorAll(
        ".teaser-icon-container",
      );
      const singleTeaserContent = container.querySelectorAll(".content");

      if (
        !headline.length &&
        !subline.length &&
        !singleTeaserIcon.length &&
        !singleTeaserContent.length
      )
        return;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          start: "top 80%",
          once: true,
          fastScrollEnd: true,
        },
      });

      if (headline.length) {
        tl.to(headline, { ...base, x: 0 });
      }

      if (subline.length) {
        tl.to(subline, { ...base, x: 0 });
      }

      if (singleTeaserContent.length) {
        tl.to(singleTeaserContent, {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "back.out(1.7, 0.5)",
          stagger: 0.15,
        });
      }

      if (singleTeaserIcon.length) {
        tl.to(
          singleTeaserIcon,
          {
            rotate: 0,
            scale: 1,
            opacity: 1,
            duration: 1,
            stagger: 0.15,
            ease: "power3.inOut",
          },
          "-=1.2",
        );
      }
    });
  };
  applyAnimations();
};

export default LowerSectionAnimation;
